<template>
  <div>
    <a-spin :spinning="loading">
      <a-row :gutter="16">
        <a-col :span="24">
          <h5 class="mb-1"></h5>
          <a-form layout="inline">
            <a-form-item :help="_trs('Delivery date')">
              <a-range-picker
                v-model="date"
                :placeholder="[_trs('Start date'), _trs('End date')]"
                valueFormat="YYYY-MM-DD"
              />
            </a-form-item>

            <a-form-item>
              <a-button class="btn btn-success" @click="searchData">{{
                _trs('Get results')
              }}</a-button>
            </a-form-item>
            <div class="pull-right">
              <a-button
                type="dashed"
                class="button-period"
                @click="setPeriod($event, 'day')"
                :size="buttonSize"
              >
                {{ _trs('Day') }}
              </a-button>
              <a-button
                type="dashed"
                class="button-period"
                @click="setPeriod($event, 'week')"
                :size="buttonSize"
              >
                {{ _trs('Week') }}
              </a-button>
              <a-button
                type="dashed"
                class="button-period"
                @click="setPeriod($event, 'month')"
                :size="buttonSize"
              >
                {{ _trs('Month') }}
              </a-button>
              <a-button
                type="dashed"
                class="button-period"
                @click="setPeriod($event, 'quartal')"
                :size="buttonSize"
              >
                {{ _trs('Quarter') }}
              </a-button>
              <a-button
                type="dashed"
                class="button-period"
                @click="setPeriod($event, 'year')"
                :size="buttonSize"
              >
                {{ _trs('Year') }}
              </a-button>
            </div>
          </a-form>

          <div>
            <h5 class="font-weight-light mb-3 mt-5">{{ _trs('Price') }}</h5>
            <a-checkbox-group
              v-model="checkedList"
              :options="plainOptions"
              @change="onChange"
            />
            <div
              class="mb-10"
              id="day-ahead-result-price-chart"
              style="height: 320px;"
            ></div>
            <h5 class="font-weight-light mb-3 mt-5">{{ _trs('Volume') }}</h5>
            <div
              class="mb-10"
              id="day-ahead-result-qty-chart"
              style="height: 320px;"
            ></div>
          </div>
        </a-col>
      </a-row>
    </a-spin>
  </div>
</template>
<script>
import { XmlService } from '@/services/api'

import { Chart } from '@antv/g2'
import { Modal } from 'ant-design-vue'
import moment from 'moment'
import { _trs } from '../../../../utilities'

export default {
  name: 'DayAheadResult',
  components: {},

  data: function () {
    return {
      dayAheadData: [],
      baseLoadBlock: null,
      peakLoadBlock: null,
      dayAheadQuantity: [],
      chartPrice: null,
      chartQty: null,

      dateFormat: 'YYYY-MM-DD',
      date: [moment().add(1, 'day'), moment().add(1, 'day')],

      buttonSize: 'small',
      loading: false,

      checkedList: [],
      plainOptions: [],

      isOneDay: null,
    }
  },
  methods: {
    _trs,
    isDateTooOld(date) {
      if (!date) return false
      const twoWeeksAgo = moment().subtract(14, 'days').startOf('day')
      return moment(date).isBefore(twoWeeksAgo)
    },
    showDateRestrictionModal() {
      Modal.warning({
        title: _trs('Data Not Available'),
        content: _trs('Data older than 2 weeks is available upon request according to the commercial terms. Contact dam@belen-spot.me for more info.'),
      })
    },
    onChange() {
      this.drawPatternChartPrice()
    },
    drawCharts() {
      this.drawPatternChartPrice()
      this.drawPatternChartQty()
      this.loading = false
    },
    async searchData() {
      if (
        this.date &&
        this.date.length &&
        (this.isDateTooOld(this.date[0]) || this.isDateTooOld(this.date[1]))
      ) {
        this.loading = false
        this.showDateRestrictionModal()
        return
      }
      this.loading = true
      var filter = {
        dayFrom: moment(this.date[0]).format('YYYY-MM-DD'),
        dayTo: moment(this.date[1]).format('YYYY-MM-DD'),
      }
      const response = await XmlService.getDayAheadResult({ filter })
      this.dayAheadData = response.data.data

      this.baseLoadBlock = response.data?.blocks.find(
        (row) => row.block_name == '01-24 (Baseload)'
      )

      this.peakLoadBlock = response.data?.blocks.find(
        (row) => row.block_name == '09-20 (Peakload)'
      )

      this.isOneDay = response.data.isOneDay
      this.dayAheadQuantity = response.data.quantity
      this.plainOptions = response.data.options
      this.checkedList = []
      this.plainOptions.forEach((element) => {
        if (element.includes('Peakload') || element.includes('Baseload')) {
          this.checkedList.push(element)
        }
      })
      if (this.checkedList.length == 0) {
        this.checkedList.push(this.plainOptions[0])
      }
      this.drawCharts()
    },
    setPeriod(e, period) {
      e.target.blur()
      let d1, d2
      if (period == 'year') {
        d2 = moment().add(1, 'day')
        d1 = moment().add(1, 'day').subtract(1, 'years')
      }
      if (period == 'quartal') {
        d2 = moment().add(1, 'day')
        d1 = moment().add(1, 'day').subtract(3, 'months')
      }
      if (period == 'month') {
        d2 = moment().add(1, 'day')
        d1 = moment().add(1, 'day').subtract(1, 'months')
      }
      if (period == 'week') {
        d2 = moment().add(1, 'day')
        d1 = moment().add(1, 'day').subtract(7, 'days')
      }
      if (period == 'day') {
        d2 = moment().add(1, 'day')
        d1 = moment().add(1, 'day')
      }

      this.date = [d1, d2]
      this.searchData()
    },
    drawPatternChartPrice() {
      if (this.chartPrice) {
        this.chartPrice.destroy()
      }

      const chart = new Chart({
        container: 'day-ahead-result-price-chart',
        autoFit: true,
      })

      if (!this.isOneDay) {
        const data = this.dayAheadData.filter((element) =>
          this.checkedList.includes(element.block_name)
        )

        chart.data(data)

        chart.scale('time', {
          alias: _trs('Time step'),
          nice: true,
          tickInterval: 1,
        })

        chart.scale('price', {
          alias: _trs('Price'),
          tickInterval: 100,
          nice: true,
        })

        chart.axis('time', true)
        chart
          .line()
          .position(`time*price`)
          .color('block_name')
          .shape('smooth')
          .tooltip('block_name*time*price', (block_name, time, price) => {
            // let formatted = formatMoney(Math.round(value * 100) / 100)
            return {
              name: block_name,
              value: (price == null ? ' - ' : price) + ' 	&euro;/MWh',
            }
          })

        chart.legend({
          position: 'bottom',
        })

        chart
          .point()
          .position('time*price')
          .color('block_name')
          .shape('circle')
          .tooltip(false)
        chart.render()

        this.chartPrice = chart
      } else {
        var data = this.dayAheadData.map((row) => {
          return {
            type: 'Price',
            ...row,
          }
        })

        if (this.baseLoadBlock && this.peakLoadBlock) {
          for (const hour of data.map((row) => row.time)) {
            data.push({
              type: 'Base price',
              time: hour,
              price: this.baseLoadBlock.block_price,
            })

            if (hour >= 9 && hour <= 20) {
              data.push({
                type: 'Peak price',
                time: hour,
                price: this.peakLoadBlock.block_price,
              })
            } else {
              data.push({
                type: 'Peak price',
                time: hour,
                price: null,
              })
            }
          }
        }

        chart.data(data)

        chart.scale('time', {
          alias: _trs('Timestep [h]'),
          nice: true,
          tickInterval: 1,
        })

        chart.scale('price', {
          nice: true,
          alias: _trs('Price [EUR/MWh]'),

          // min: 0,
          // tickInterval: 100,
        })

        chart.axis('time', {
          title: {},
        })

        chart.axis('price', {
          title: {},
        })

        chart.tooltip({
          showTitle: false,
        })

        chart
          .line()
          .position(`time*price`)
          .color('type')
          // .shape('smooth')
          .tooltip('type*time*price', (type, time, price) => {
            // let formatted = formatMoney(Math.round(value * 100) / 100)
            return {
              name: type,
              value: (price == null ? ' - ' : price) + ' 	&euro;/MWh',
            }
          })

        chart
          .point()
          .position('time*price')
          .color('type')
          .shape('circle')
          .tooltip(false)

        chart.legend({
          position: 'bottom',
          // marker: 'square',
        })

        chart.render()

        this.chartPrice = chart
      }
    },
    drawPatternChartQty() {
      if (this.chartQty) {
        this.chartQty.destroy()
      }

      const data = this.dayAheadQuantity

      const chart = new Chart({
        container: 'day-ahead-result-qty-chart',
        autoFit: true,
      })

      chart.data(data)

      chart.axis('time', {
        title: {},
      })

      chart.axis('quantity', {
        title: {},
      })

      chart.scale('time', {
        nice: true,
        tickInterval: 1,
        alias: _trs('Timestep [h]'),
      })

      chart.scale('quantity', {
        min: 0,
        alias: _trs('Volume [MWh]'),
      })

      chart.tooltip({
        showMarkers: false,
      })

      chart.tooltip({
        showTitle: false,
      })

      chart
        .interval()
        .position('time*quantity')
        .tooltip()
        .tooltip('time*quantity', (time, quantity) => {
          // let formatted = formatMoney(Math.round(value * 100) / 100)
          return {
            name: 'Volume',
            value: (quantity == null ? ' - ' : quantity) + ' MWh',
          }
        })

      chart.interaction('element-active')

      chart.interaction('element-active')

      chart.render()

      this.chartQty = chart
    },
  },
  mounted() {
    this.searchData()
  },
}
</script>
<style>
.button-period {
  margin-left: 10px;
}
.ant-checkbox-group-item {
  width: 20%;
}

.ant-checkbox-wrapper {
  width: 20%;
}
</style>
